module.exports = __webpack_public_path__ + "img/banner_z_flip.b0a1d56c.jpg";